import Global from './global';

// Import Bootstrap CSS & JS
import 'bootstrap/dist/css/bootstrap.min.css';

//import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Import bootstrap-slider
import 'bootstrap-slider';

import $ from 'jquery';
import { SheetHelper } from "./sheetHelper";

class FilterHelperClass {
    desktopBreakpoint = 768;

    private distanceSlider?: JQuery<HTMLElement>;
    private priceSlider?: JQuery<HTMLElement>;

    private priceSliderDefaults: [number, number] | null = null;
    private distanceSliderDefaults: [number, number] | null = null;

    public initFilters(): void {
        // Filters buttons to open sheet
        const filterBtns = document.querySelectorAll<HTMLButtonElement>('.btn-open-filters');
        filterBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const currentSheet = document.querySelector<HTMLElement>(".filters-sheet");
                if (!currentSheet) return;

                SheetHelper.closeOtherSheets(currentSheet);
                SheetHelper.toggleSheet(currentSheet);
            });
        });

        // Filters button tp close sheet (Apply)
        const closeBtn = document.querySelector<HTMLButtonElement>('.btn-close-filters');
        closeBtn?.addEventListener('click', () => {
            const sheet = document.querySelector<HTMLElement>(".filters-sheet");
            if (sheet) {
                SheetHelper.closeSheet(sheet);
            }
        });

        // Filters clear button
        const clearBtn = document.querySelector<HTMLButtonElement>('.btn-clear-filters');
        clearBtn?.addEventListener('click', () => {
            this.clearAllFilters();
        });

        // Initialize filter events
        this.initFilterEvents();

        // Initialize sliders
        this.initDistanceSlider();
        this.initPriceSlider();

        // Initialize the See More/See Less Links
        this.initSeeMoreFilters();
    }

    private clearAllFilters(): void {
        const wrapper = document.querySelector(".filters-wrapper");
        if (!wrapper) return;

        // Uncheck all checkboxes
        wrapper.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach(cb => {
            cb.checked = false;
        });

        // Reset price slider
        if (this.priceSlider && this.priceSliderDefaults) {
            this.priceSlider.slider('setValue', this.priceSliderDefaults, true, true);
        }

        // Reset distance slider
        if (this.distanceSlider && this.distanceSliderDefaults) {
            this.distanceSlider.slider('setValue', this.distanceSliderDefaults, true, true);
        }

        // Filter hotels now with nothing selected
        this.filterHotels();
    }

    private initSeeMoreFilters = (): void => {
        // Show "Show All" button if any checkboxes are hidden
        $('.filter-item').each((_, obj) => {
            const $obj = $(obj);
            if ($obj.hasClass('hidden')) {
                $obj.parent().find('.btn-show-all-filter').removeClass('hidden');
            }
        });

        // Click "Show All" button
        $(document).on('click', '.btn-show-all-filter', function (e) {
            e.preventDefault();
            const $btn = $(this);
            const $group = $btn.parent();

            $group.children('.filter-item').each((_, obj) => {
                const $item = $(obj);
                if ($item.hasClass('hidden')) {
                    $item.removeClass('hidden');
                }
            });

            $btn.addClass('hidden');
            $group.find('.btn-hide-all-filter').removeClass('hidden');
        });

        // Click "Hide All" button
        $(document).on('click', '.btn-hide-all-filter', function (e) {
            e.preventDefault();
            const $btn = $(this);
            const $group = $btn.parent();

            $group.children('.filter-item').each((index, obj) => {
                const $item = $(obj);
                if (index >= 5) {
                    $item.addClass('hidden');
                }
            });

            $btn.addClass('hidden');
            $group.find('.btn-show-all-filter').removeClass('hidden');
        });
    };

    private calculateDistanceInKmWithLabel(distance: number): string {
        return distance > 0.999 ? `${distance} km` : `${Math.round(distance * 1000)} m`;
    }

    private initDistanceSlider(): void {
        const hotelListings = document.querySelectorAll<HTMLElement>('.hotel-list-card');
        const distancesArray = Array.from(hotelListings)
            .map(h => parseFloat($(h).data('distance') ?? '0'))
            .filter(d => d !== 9999);

        if (!distancesArray.length) return;

        let minDist = Math.min(...distancesArray);
        let maxDist = Math.max(...distancesArray);
        if (minDist === 0) minDist = 1;
        if (minDist === maxDist || distancesArray.length <= 2) {
            document.querySelector('.filter-group.distance')?.classList.add('hidden');
            return;
        }

        this.distanceSlider = $('#distanceSlider');
        this.distanceSlider.slider({
            min: minDist,
            max: maxDist,
            step: 0.01,
            value: [minDist, maxDist],
            tooltip: 'show',
            formatter: (value) => {
                // If it's a range (array), format both ends
                if (Array.isArray(value)) {
                    return `${value[0]} km – ${value[1]} km`;
                }
                // Fallback for single-value sliders
                return `${value}Km`;
            }
        });

        // Add labels after slider initializes
        $('.min-slider-handle').attr('aria-label', `Minimum Distance: €${minDist} km`);
        $('.max-slider-handle').attr('aria-label', `Maximum Distance: €${maxDist} km`);

        this.distanceSliderDefaults = [minDist, maxDist];

        this.distanceSlider.on('slide change', () => this.filterHotels());

        const minDisplay = document.getElementById('minDistanceDisplay');
        const maxDisplay = document.getElementById('maxDistanceDisplay');
        if (minDisplay) minDisplay.textContent = this.calculateDistanceInKmWithLabel(minDist);
        if (maxDisplay) maxDisplay.textContent = this.calculateDistanceInKmWithLabel(maxDist);
    }

    private initPriceSlider(): void {
        const hotelListings = document.querySelectorAll<HTMLElement>('.hotel-list-card');
        const pricesArray = Array.from(hotelListings)
            .map(h => Math.round(parseFloat($(h).data('price') ?? '0')))
            .filter(p => p !== -1);

        if (!pricesArray.length) return;

        const minPrice = Math.floor(Math.min(...pricesArray));
        const maxPrice = Math.ceil(Math.max(...pricesArray));
        if (minPrice === maxPrice || pricesArray.length <= 2) {
            document.querySelector('.filter-group.budget')?.classList.add('hidden');
            return;
        }

        // Render histogram
        this.renderHistogram('priceHistogram', pricesArray, minPrice, maxPrice, 30);

        this.priceSlider = $('#priceSlider');
        this.priceSlider.slider({
            min: minPrice,
            max: maxPrice,
            step: 1,
            value: [minPrice, maxPrice],
            tooltip: 'show',
            formatter: (value) => {
                // If it's a range (array), format both ends
                if (Array.isArray(value)) {
                    return `€${value[0]} – €${value[1]}`;
                }
                // Fallback for single-value sliders
                return `€${value}`;
            }
        });

        // Add labels after slider initializes
        $('.min-slider-handle').attr('aria-label', `Minimum price: €${minPrice}`);
        $('.max-slider-handle').attr('aria-label', `Maximum price: €${maxPrice}`);

        this.priceSliderDefaults = [minPrice, maxPrice];

        this.priceSlider.on('slide change', () => this.filterHotels());

        const minDisplay = document.getElementById('minPriceDisplay');
        const maxDisplay = document.getElementById('maxPriceDisplay');
        if (minDisplay) minDisplay.textContent = `€${minPrice.toString()}`;
        if (maxDisplay) maxDisplay.textContent = `€${maxPrice.toString()}`;
    }

    private renderHistogram(containerId: string, data: number[], min: number, max: number, bins = 20): void {
        const container = document.getElementById(containerId);
        if (!container) return;

        container.innerHTML = ''; // clear old bars

        const binSize = (max - min) / bins;
        const counts = Array(bins).fill(0);
        data.forEach(d => {
            const idx = Math.min(Math.floor((d - min) / binSize), bins - 1);
            counts[idx]++;
        });

        const maxCount = Math.max(...counts, 1);

        counts.forEach(count => {
            const bar = document.createElement('div');
            bar.className = 'histogram-bar';
            bar.style.height = `${(count / maxCount) * 100}%`;
            container.appendChild(bar);
        });
    }

    private initFilterEvents(): void {
        // Available checkbox
        const availableFilterField = document.querySelector<HTMLInputElement>('.available-filter');
        availableFilterField?.addEventListener('change', () => this.filterHotels());

        // Star Rating checkboxes
        document.querySelectorAll<HTMLInputElement>('.star-rating-checkbox').forEach(f => f.addEventListener('change', () => this.filterHotels()));

        // Facility checkboxes
        document.querySelectorAll<HTMLInputElement>('.facility-filter').forEach(f => f.addEventListener('change', () => this.filterHotels()));

        // POI checkboxes
        document.querySelectorAll<HTMLInputElement>('.poi-filter').forEach(f => f.addEventListener('change', () => this.filterHotels()));

        // Theme checkboxes
        document.querySelectorAll<HTMLInputElement>('.theme-filter').forEach(t => t.addEventListener('change', () => this.filterHotels()));

        // Map/location filters
        document.addEventListener('change', (e) => {
            const target = e.target as HTMLInputElement;
            if (target.matches('.map-location-filter') || target.matches('.location-filter')) {
                this.filterHotels();
            }
        });
    }

    private filterHotels(): void {
        const container = document.querySelectorAll<HTMLElement>('.hotel-list-card');
        if (!container) return;

        (window as any).MapHelper?.removeMiniMarkersLayer?.();
        (window as any).MapHelper?.removeMainMarkersLayer?.();

        let scrollToTop = false;
        
        const availableFilterField = document.querySelector<HTMLInputElement>('.available-filter');
        const noAvailabilityChecked = availableFilterField?.checked ?? false;

        const starFilters = document.querySelectorAll<HTMLInputElement>('.star-rating-group .star-rating-checkbox');
        const selectedStarRatings: string[] = [];
        starFilters.forEach(f => {
            if (f.checked) selectedStarRatings.push(f.dataset.starRanking!);
        });
        const noStarFiltersChecked = selectedStarRatings.length === 0;

        const facilityFilterField = document.querySelectorAll<HTMLInputElement>('.facility-filter');
        const noFacilitiesChecked = Array.from(facilityFilterField).every(f => !f.checked);

        const poiFilterField = document.querySelectorAll<HTMLInputElement>('.poi-filter');
        const noPoiChecked = Array.from(poiFilterField).every(f => !f.checked);

        const themeFilterField = document.querySelectorAll<HTMLInputElement>('.theme-filter');
        const noThemesChecked = Array.from(themeFilterField).every(t => !t.checked);

        const mapLocationFilters = document.querySelectorAll<HTMLInputElement>('.map-location-filter');
        const selectedMapLocations: string[] = [];
        mapLocationFilters.forEach(f => {
            if (f.checked) selectedMapLocations.push(f.id);
        });
        const noMapLocationsChecked = selectedMapLocations.length === 0;

        const locationFilters = document.querySelectorAll<HTMLInputElement>('.location-filter');
        const selectedLocations: string[] = [];
        locationFilters.forEach(f => {
            if (f.checked) selectedLocations.push(f.id);
        });
        const noLocationsChecked = selectedLocations.length === 0;

        const distanceSlider = $('#distanceSlider').val()?.toString().split(',').map(Number) ?? [];
        const priceSlider = $('#priceSlider').val()?.toString().split(',').map(Number) ?? [];


        container.forEach(hotel => {
            let hideHotel = false;
            const currDistance = parseFloat($(hotel).data('distance') ?? '0');
            const currPrice = Math.round(parseFloat($(hotel).data('price') ?? '0'));

            // Apply all filters
            if (noAvailabilityChecked && hotel.classList.contains('unavailable')) {
                hideHotel = true;
            }

            if (!noStarFiltersChecked) {
                const hotelRanking = $(hotel).data('star-ranking').toString();
                // Show hotel if it matches any selected star rating
                if (!selectedStarRatings.includes(hotelRanking)) {
                    hideHotel = true;
                }
            }

            if (!noFacilitiesChecked) {
                const facilityIds: string[] = ($(hotel).data('facility-ids') as string)?.split(',').map(i => i.trim()) ?? [];
                facilityFilterField.forEach(f => { if (f.checked && !facilityIds.includes(f.id)) hideHotel = true; });
            }

            if (!noPoiChecked) {
                const poiIds: string[] = ($(hotel).data('poi-ids') as string)?.split(',').map(i => i.trim()) ?? [];
                poiFilterField.forEach(poi => { if (poi.checked && !poiIds.includes(poi.id)) hideHotel = true; });
            }

            if (!noThemesChecked) {
                const themeIds: string[] = ($(hotel).data('theme-ids') as string)?.split(',').map(i => i.trim()) ?? [];
                themeFilterField.forEach(t => { if (t.checked && !themeIds.includes(t.id)) hideHotel = true; });
            }

            // Map locations (town-level)
            if (!noMapLocationsChecked) {
                const hotelMapLocationId = $(hotel).data('map-location-id') as string;
                // Show hotel if it matches any selected town
                if (!selectedMapLocations.includes(hotelMapLocationId)) {
                    hideHotel = true;
                }
            }

            // Locations (county-level)
            if (!noLocationsChecked) {
                const hotelLocationId = $(hotel).data('location-id') as string;
                // Show hotel if it matches any selected county
                if (!selectedLocations.includes(hotelLocationId)) {
                    hideHotel = true;
                }
            }

            const minPrice = Math.round(priceSlider[0] ?? -Infinity);
            const maxPrice = Math.round(priceSlider[1] ?? Infinity);
            const minDist = Math.floor(distanceSlider[0] ?? -Infinity);
            const maxDist = Math.ceil(distanceSlider[1] ?? Infinity);

            const priceWithin = isNaN(minPrice) || isNaN(maxPrice) || (minPrice <= currPrice && currPrice <= maxPrice);
            const distWithin = isNaN(minDist) || isNaN(maxDist) || (minDist <= currDistance && currDistance <= maxDist);

            if ((currPrice > -1 && (!priceWithin || !distWithin)) || !distWithin) hideHotel = true;

            if (hideHotel) {
                hotel.classList.add('hidden');
                (window as any).MapHelper?.hideMarker?.($(hotel).data('hotel-id'));
            } else {
                hotel.classList.remove('hidden');
                (window as any).MapHelper?.showMarker?.($(hotel).data('hotel-id'));
            }
        });

        $(".hotel-count").html(
            $(".hotel-list-card").not(".hidden").length.toString()
        );

        (window as any).MapHelper?.addMainMarkersLayer?.();
        if (scrollToTop) window.scrollTo({ top: 0, behavior: 'smooth' });

        const soldOutHotelsAlert = document.querySelectorAll<HTMLElement>('.sold-out-hotels');
        soldOutHotelsAlert.forEach(el => {
            el.classList.add("hidden");
        });

        Global.checkLazyImages();
    }
}

// Create global instance
export const FilterHelper = new FilterHelperClass();
